import Entity from '../entity'

export default class Holiday extends Entity<number>{
    year: number;
    holiday_date: string;
}


